goog.module('yext.location.UberEmbedLink');
goog.module.declareLegacyNamespace();

/**
 * @param {!jQuery} $ctx Context for this embed field
 * @author MattJS (matt@yext.com)
 * @constructor
 */
const UberEmbedLink = function($ctx) {
  this.$ctx = $ctx;
  this.$textarea = this.$ctx.find('textarea');

  this.buttonTemplate = this.$ctx.find('.js-uber-embed-button-template').text();
  this.textTemplate = this.$ctx.find('.js-uber-embed-text-template').text();

  this.bindFocusHighlight();
  this.bindCopy();
};

UberEmbedLink.prototype.bindFocusHighlight = function() {
  var self = this;
  this.$textarea.on('focus', function() {
    self.$textarea.select();
  });
};

/**
 * @param {!Object} field Data about the Uber launch link after it has been saved
 */
UberEmbedLink.prototype.update = function(field) {
  var presentation = field['presentation']['value'];
  var linkText = field['text']['value'];
  var html;

  if (presentation === 'BUTTON') {
    html = this.buttonTemplate;
  } else {
    html = this.textTemplate.replace('&#123;&#123;EMBEDLINK&#125;&#125;', linkText);
  }

  this.$textarea.html(html);
};


UberEmbedLink.prototype.bindCopy = function() {
  var self = this;
  var $copiedMessage = this.$ctx.find('.js-copied-message');

  this.$ctx.find('.js-copy-uber-embed-link').on('click', function() {
    self.$textarea.select();
    var successful;

    try {
      successful = document.execCommand('copy');
    } catch (err) {
      successful = false;
    }

    if (!successful) { // Fallback to a prompt where they can copy
      // TRANSLATORS: Ctrl+C and Enter are keyboard
      window.prompt(yext.msg('Copy to clipboard: Ctrl+C, Enter'), self.$textarea.text());
    } else {
      $copiedMessage.stop(true, true).fadeIn();
      setTimeout(function() {
        $copiedMessage.stop(true, true).fadeOut();
      }, 2000);
    }

    // Remove selection
    if (document.selection) {
      document.selection.empty();
    } else if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
  });
};

exports = UberEmbedLink;
